<template>
  <!-- Start Preloader Area -->
  <div class="preloader">
    <div class="container">
      <div class="avatar">
        <img src="../../assets/img/logo.svg" alt="IT+" />
      </div>
    </div>
  </div>
  <!-- End Preloader Area -->
</template>
<style lang="scss" scoped>
body,
html {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: "Helvetica", sans-serif;
  background: rgb(26, 188, 156);
  background: -moz-linear-gradient(-45deg,
      rgba(26, 188, 156, 1) 0%,
      rgba(142, 68, 173, 1) 100%);
  background: -webkit-linear-gradient(-45deg,
      rgba(26, 188, 156, 1) 0%,
      rgba(142, 68, 173, 1) 100%);
  background: linear-gradient(135deg,
      rgba(26, 188, 156, 1) 0%,
      rgba(142, 68, 173, 1) 100%);
}

h1 {
  font-size: 24px;
  margin: 10px 0 0 0;
  font-weight: lighter;
  text-transform: uppercase;
  color: #eeeeee;
}

p {
  font-size: 12px;
  font-weight: light;
  color: #333333;
}

span a {
  font-size: 18px;
  color: #cccccc;
  text-decoration: none;
  margin: 0 10px;
  transition: all 0.4s ease-in-out;

  &:hover {
    color: #ffffff;
  }
}

@keyframes float {
  0% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    transform: translatey(0px);
  }

  50% {
    box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
    transform: translatey(-20px);
  }

  100% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    transform: translatey(0px);
  }
}

.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.avatar {
  width: 150px;
  height: 150px;
  box-sizing: border-box;
  border: 5px white solid;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
  transform: translatey(0px);
  animation: float 6s ease-in-out infinite;
  background: white;
  position: relative;

  img {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.content {
  width: 100%;
  max-width: 600px;
  padding: 20px 40px;
  box-sizing: border-box;
  text-align: center;
}

.suppoprt-me {
  display: inline-block;
  position: fixed;
  bottom: 10px;
  left: 10px;
  width: 20vw;
  max-width: 250px;
  min-width: 200px;
  z-index: 9;

  img {
    width: 100%;
    height: auto;
  }
}
</style>
